"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SalesForceStatus;
(function (SalesForceStatus) {
    SalesForceStatus.NOT_LINK = '0';
    SalesForceStatus.LINKD = '10';
})(SalesForceStatus = exports.SalesForceStatus || (exports.SalesForceStatus = {}));
/**
 *
 */
var SalesForceVersion;
(function (SalesForceVersion) {
    SalesForceVersion[SalesForceVersion["VER_1"] = 0] = "VER_1";
})(SalesForceVersion = exports.SalesForceVersion || (exports.SalesForceVersion = {}));



//////////////////
// WEBPACK FOOTER
// ./common/src/types/model/sales_force_info/entity.ts
// module id = oMjQ
// module chunks = 1